import { AnalyticsContext } from '@carvana/eventable-clickstream';
import classnames from 'classnames';
import { useContext, useRef } from 'react';
import type React from 'react';
import SearchSource from '~/constants/SearchSource';
import SearchEventsDataContext from '~/contexts/SearchEventsDataContext';
import ObservableTile from '../ObservableTile/ObservableTile';

type OwnProps = React.PropsWithChildren<{
  isRelative?: boolean;
  tileId?: string;
  link?: string;
  name?: string;
  backgroundLink?: string;
  handleBackground?: string;
  bgOffsetY?: string;
  darkenBackground?: boolean;
  experiment?: boolean;
  styles?: { [key: string]: string };
  smallerSize?: boolean;
  handleTileClick?: (e: React.MouseEvent) => void;
}>;

export default function ClickableTile({
  isRelative = false,
  tileId,
  link,
  name,
  styles,
  children,
  backgroundLink,
  smallerSize,
  experiment = false,
  handleTileClick = () => null
}: OwnProps) {
  const { setSearchSource } = useContext(SearchEventsDataContext);
  const { trackEvent } = useContext(AnalyticsContext);

  const trackClick = () => {
    trackEvent('Conditional tile - clicked', {
      tile: name
    });
  };

  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = e => {
    trackClick();
    handleTileClick(e);
    if (tileId === 'GreatDealTile') {
      setSearchSource(SearchSource.Tile);
    }
  };

  const ref = useRef(null);

  return (
    <ObservableTile
      observeRef={ref}
      name={name}
      onVisible={() => {
        trackEvent('Conditional tile - viewed', { tile: name });
      }}
    >
      <div
        className={classnames(
          'ct-wrapper m:border-solid m:border m:rounded-md m:border-grey-2',
          tileId,
          {
            'ct-wrapper-experiment': experiment,
            'ct-wrapper-sm': smallerSize,
            relative: isRelative
          }
        )}
        id={name}
      >
        <a
          className={classnames('ct-anchor', {
            'ct-anchor-no-padding': backgroundLink,
            relative: isRelative
          })}
          style={{ ...styles }}
          href={link}
          id={tileId}
          onClick={handleClick}
          onContextMenu={trackClick}
        >
          {children}
        </a>
      </div>
    </ObservableTile>
  );
}
